import type { CSSProperties } from 'react';
import { adminField, adminFocusable, adminTokens as a } from '../../admin-ui';

interface SearchableContextPickerStyleOptions {
  triggerMinWidth: string;
  triggerMaxWidth: string;
  dropdownWidth: string;
  listMaxHeight: string;
}

/** Shell context pickers (language, content context): admin chrome. */
export function createSearchableContextPickerStyles(
  options: SearchableContextPickerStyleOptions,
): Record<string, CSSProperties> {
  return {
    container: { position: 'relative', minWidth: 0 },
    trigger: {
      ...adminFocusable,
      height: '40px',
      minWidth: options.triggerMinWidth,
      maxWidth: options.triggerMaxWidth,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: a.spacing.sm,
      padding: `0 ${a.spacing.md} 0 ${a.spacing.md}`,
      borderRadius: a.radius.control,
      border: `1px solid ${a.border.control}`,
      backgroundColor: a.surface.panel,
      color: a.text.primary,
      fontSize: a.typography.body.size,
      fontWeight: 500,
      fontFamily: a.typography.fontFamily,
      cursor: 'pointer',
      textAlign: 'left',
      boxSizing: 'border-box',
    },
    triggerLabel: {
      flex: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    dropdown: {
      position: 'absolute',
      top: `calc(100% + ${a.spacing.xs})`,
      right: 0,
      width: options.dropdownWidth,
      maxWidth: 'calc(100vw - 32px)',
      backgroundColor: a.surface.panel,
      border: `1px solid ${a.border.subtle}`,
      borderRadius: a.radius.tile,
      boxShadow: a.shadow.overlay,
      zIndex: 200,
      overflow: 'hidden',
      fontFamily: a.typography.fontFamily,
    },
    searchWrapper: {
      position: 'relative',
      padding: `${a.spacing.sm} ${a.spacing.md}`,
      borderBottom: `1px solid ${a.border.subtle}`,
    },
    searchIcon: {
      position: 'absolute',
      left: `calc(${a.spacing.md} + 10px)`,
      top: '50%',
      transform: 'translateY(-50%)',
      color: a.text.secondary,
      display: 'inline-flex',
      alignItems: 'center',
      fontSize: '13px',
      pointerEvents: 'none',
    },
    searchInput: {
      ...adminField.input,
      width: '100%',
      height: '34px',
      padding: `0 ${a.spacing.md} 0 32px`,
      fontSize: a.typography.label.size,
    },
    list: {
      listStyle: 'none',
      margin: 0,
      padding: a.spacing.xs,
      maxHeight: options.listMaxHeight,
      overflowY: 'auto',
    },
    listItemHovered: {
      backgroundColor: a.surface.canvas,
    },
    listItemSelected: {
      color: a.text.primary,
      fontWeight: 700,
      backgroundColor: a.navigation.selected,
    },
    statusItem: {
      padding: `${a.spacing.sm} ${a.spacing.md}`,
      fontSize: a.typography.label.size,
      color: a.text.secondary,
      cursor: 'default',
    },
  };
}
